import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from 'react';
import Login from './pages/Login'
import UnifiedSearch from './pages/UnifiedSearch'
import WearerDashboard from "./pages/WearerDashboard";
import TabletDashboard from "./pages/TabletDashboard";
import Tools from "./pages/Tools";
import ChangePassword from "./pages/ChangePassword";
import MfaChallenge from "./pages/MfaChallenge";
import Admin from "./pages/Admin";
import RequireAuth from "./components/RequireAuth";
import RequireAdmin from "./components/RequireAdmin";
import NotFound from "./pages/NotFound";
import MainLayout from "./layouts/layout";
import './App.css';
import AuthProvider from "./authContext";
import SimDashboard from "./pages/SimDashboard";
import {
  SubscriptionInsightsDashboard,
  SubscriptionInsightsOperatorDetail,
  subscriptionInsightsModule,
} from "./modules/subscriptionInsights";


// /sim y /tablet se unificaron con la búsqueda de relojes. Se conserva el query
// string para que los links con ?searchTxt= sigan funcionando.
function RedirectToSearch() {
  const { search } = useLocation();
  return <Navigate to={`/${search}`} replace />;
}

function App() {

  // const [tokens, setTokens] = useState(null)

  return (
    <AuthProvider>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login/>}/>
          <Route path="/" element={<RequireAuth><UnifiedSearch/></RequireAuth>}/>
          <Route path="/wearer" element={<RequireAuth><WearerDashboard/></RequireAuth>}/>
          <Route path="/sim/dashboard" element={<RequireAuth><SimDashboard/></RequireAuth>}/>
          <Route path="/sim" element={<RedirectToSearch/>}/>
          <Route path="/tablet/dashboard" element={<RequireAuth><TabletDashboard/></RequireAuth>}/>
          <Route path="/tablet" element={<RedirectToSearch/>}/>
          <Route path="/herramientas" element={<RequireAuth><Tools/></RequireAuth>}/>
          <Route path="/change-password" element={<ChangePassword/>}/>
          <Route path="/mfa" element={<MfaChallenge/>}/>
          <Route path="/agentes" element={<RequireAuth><Admin/></RequireAuth>}/>
          <Route
            path={subscriptionInsightsModule.path}
            element={
              <RequireAuth>
                <RequireAdmin>
                  <MainLayout currentView={subscriptionInsightsModule.menuKey}>
                    <SubscriptionInsightsDashboard />
                  </MainLayout>
                </RequireAdmin>
              </RequireAuth>
            }
          />
          <Route
            path={subscriptionInsightsModule.detailPath}
            element={
              <RequireAuth>
                <RequireAdmin>
                  <MainLayout currentView={subscriptionInsightsModule.menuKey}>
                    <SubscriptionInsightsOperatorDetail />
                  </MainLayout>
                </RequireAdmin>
              </RequireAuth>
            }
          />
          <Route path="*" element={<NotFound/>} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
